/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_Bank_NameInputs */

const vi_payment_qr_bank_name = /** @type {(inputs: Payment_Qr_Bank_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngân hàng`)
};

/**

* @param {Payment_Qr_Bank_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_bank_name = /** @type {((inputs?: Payment_Qr_Bank_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_Bank_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_bank_name(inputs)
});